export const SDInputOverrides = () => ({
  Input: {
    style: ({ $theme }) => ({
      color: $theme.colors.black,
      paddingRight: '.75rem',
      paddingLeft: '.45rem',
    }),
  },
  InputContainer: {
    style: { paddingTop: '0.625rem' },
  },
  EndEnhancer: {
    style: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '2rem',
      padding: '0.625rem 0 0 0',
    },
  },
})